import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Typography, Card, CardContent, Radio, List, ListItem, ListItemText, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { openLoginModal } from 'store/slice/HeaderSlice';
import { setselectedPkgObj } from 'store/slice/EcomSlice';
import LoginActionModal from 'core/components/login/LoginActionModal';
import { convertToRS } from 'core/js/FormUtils';
import ProductPage from 'components/product/page/ProductPage';
import AlreadyOnboarded from 'components/mlmuser/action/onboard/AlreadyOnboarded';

export default function SelectPackage({setStage}) {
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null);
    const {userprofileInfo} = useSelector((state) => state.headerslice);
    const {productObj} = useSelector((state) => state.dmpslice.productDashboard);
    const {mlmUserObj} = useSelector((state) => state.ecomslice.mlm);
    const [alreadyBA, setAlreadyBA] = useState(false);

    useEffect(() => {
        console.log("userprofileInfo ===>", userprofileInfo);
        console.log("mlmUserObj ==>", mlmUserObj);
        if (userprofileInfo && userprofileInfo.rolename === 'MLM_PARTNER' && mlmUserObj!=null && mlmUserObj.partnershipstatus === 'CONFIRMED') {
            console.log("USER is already Business Associates.");
            setAlreadyBA(true);
        }
    }, [userprofileInfo?.rolename, mlmUserObj?.partnershipstatus]);

    useEffect(() => {
        console.log("productObj==>", productObj);
        if (productObj) {
            if (userprofileInfo && userprofileInfo.username == 'customer.dmp.01') {
            dispatch(openLoginModal(true));
            
        } else {
            console.log("ELSE ==>", );
            dispatch(setselectedPkgObj(productObj));
            setStage('PRE_PAYMENT_REVIEW');
        }
        }
    },[productObj]);
    
    return (
        <>
        
            <Grid container xs={12} direction="row" justifyContent="flex-end" sx={{ width: '100%' }} >
                {
                    alreadyBA ? <AlreadyOnboarded/> :
                    <>
                        <Grid item xs={12}>
                            <Typography variant="h4" color="primary.darker">Select A Product</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ paddingTop: 1 }}>
                            <ProductPage setSelected={setSelected} />   
                        </Grid>
                    </>
                }
            </Grid>
            <LoginActionModal />
        </>
    )
}